'use client'

import { useState } from 'react'
import { BetaSignUpModal } from './BetaSignUpModal'

export function BetaSignUpButton() {
  const [modalOpen, setModalOpen] = useState(false)

  return (
    <>
      <button
        onClick={() => setModalOpen(true)}
        className="btn-primary"
        aria-label="Create an account"
      >
        Create an account
      </button>
      <BetaSignUpModal open={modalOpen} onOpenChange={setModalOpen} />
    </>
  )
}

